
export function current_date() {
//    获取当前日期，格式为YYYY-01-01
    var date = new Date();
    var year = date.getFullYear();
    return year + '-01-01 00:00:00'
}